import "./sections-env.css";
import * as Hero from "./Hero";
import * as FeatureGrid from "./FeatureGrid";
import * as PricingTable from "./PricingTable";
import * as FAQ from "./FAQ";
import * as Testimonials from "./Testimonials";
import * as CTABanner from "./CTABanner";
import * as BlogGrid from "./BlogGrid";
import * as BlogList from "./BlogList";
import * as CustomEmbed from "./CustomEmbed";
import * as TextBlock from "./TextBlock";
import * as ImageText from "./ImageText";
import * as StatsBar from "./StatsBar";
import * as BookingWidget from "./BookingWidget";
import * as ProcessSteps from "./ProcessSteps";
import * as ContactCard from "./ContactCard";
import * as TeamGrid from "./TeamGrid";
import * as FeatureShowcase from "./FeatureShowcase";
import * as FeatureList from "./FeatureList";
import * as CTACards from "./CTACards";
import * as ComparisonTable from "./ComparisonTable";
import * as LogoStrip from "./LogoStrip";
import * as VideoEmbed from "./VideoEmbed";
import * as MapEmbed from "./MapEmbed";
import * as LeadForm from "./LeadForm";

/**
 * Registry of all section modules. Each entry exposes:
 *   - schema (Zod)
 *   - defaults
 *   - Component
 *
 * Adding or removing a section here requires updating the inspector
 * visibility map at portal/app/src/routes/website/page-canvas/inspector/fieldVisibility.ts.
 * That file uses `satisfies Record<SectionType, …>` and will fail
 * type-check until every section has an entry.
 */
export const sectionRegistry = {
  Hero,
  FeatureGrid,
  PricingTable,
  FAQ,
  Testimonials,
  CTABanner,
  BlogGrid,
  BlogList,
  CustomEmbed,
  TextBlock,
  ImageText,
  StatsBar,
  BookingWidget,
  ProcessSteps,
  ContactCard,
  TeamGrid,
  FeatureShowcase,
  FeatureList,
  CTACards,
  ComparisonTable,
  LogoStrip,
  VideoEmbed,
  MapEmbed,
  LeadForm,
} as const;

export type SectionType = keyof typeof sectionRegistry;
